var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "question-edit",
      on: {
        mousemove: _vm.mousemove,
        mouseleave: _vm.emitData,
        click: function($event) {
          return _vm.setUeEditorShow(false)
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.question,
            rules: _vm.rules,
            "label-width": "55px"
          }
        },
        [
          _c(
            "div",
            { staticClass: "fx-box" },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "is-required",
                  attrs: { label: "", prop: "questionType" }
                },
                [
                  _c("template", { slot: "label" }, [
                    _c(
                      "span",
                      {
                        on: {
                          dblclick: function($event) {
                            _vm.question.typeEdit = !_vm.question.typeEdit
                          }
                        }
                      },
                      [_vm._v("题类")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("question-types", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      "is-children": !!_vm.data.parentId,
                      disabled: !!_vm.question.id && !_vm.question.typeEdit,
                      clearable: false
                    },
                    on: { change: _vm.questionTypeChange },
                    model: {
                      value: _vm.question.questionType,
                      callback: function($$v) {
                        _vm.$set(_vm.question, "questionType", $$v)
                      },
                      expression: "question.questionType"
                    }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "is-required",
                  attrs: { label: "题型", prop: "questionTypeTag" }
                },
                [
                  _c("question-tags", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      type: 1,
                      cache: _vm.type == "upload",
                      update: _vm.update
                    },
                    model: {
                      value: _vm.question.questionTypeTag,
                      callback: function($$v) {
                        _vm.$set(_vm.question, "questionTypeTag", $$v)
                      },
                      expression: "question.questionTypeTag"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "专业课程",
                    prop: "subjectCatalogueId",
                    "label-width": "90px"
                  }
                },
                [
                  _vm.platform == "pc"
                    ? _c("professional-list", {
                        staticStyle: { width: "150px" },
                        model: {
                          value: _vm.question.subjectCatalogueId,
                          callback: function($$v) {
                            _vm.$set(_vm.question, "subjectCatalogueId", $$v)
                          },
                          expression: "question.subjectCatalogueId"
                        }
                      })
                    : _c("professional-tree", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          root: 1,
                          config: { checkStrictly: false },
                          clearable: false
                        },
                        on: { change: _vm.subjectCatalogueChange },
                        model: {
                          value: _vm.question.subjectCatalogueId,
                          callback: function($$v) {
                            _vm.$set(_vm.question, "subjectCatalogueId", $$v)
                          },
                          expression: "question.subjectCatalogueId"
                        }
                      })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "is-required",
                  attrs: {
                    label: "难度星级",
                    prop: "difficulty",
                    "label-width": "90px"
                  }
                },
                [
                  _c("el-rate", {
                    staticClass: "mt-5",
                    staticStyle: { width: "150px" },
                    attrs: {
                      colors: ["#f56c6c", "#f56c6c", "#f56c6c"],
                      "disabled-void-color": "#ccc"
                    },
                    model: {
                      value: _vm.question.difficulty,
                      callback: function($$v) {
                        _vm.$set(_vm.question, "difficulty", $$v)
                      },
                      expression: "question.difficulty"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.type == "industry"
            ? _c(
                "div",
                { staticClass: "fx-box" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "时间", prop: "year" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "150px" },
                        attrs: { type: "date", placeholder: "选择日期" },
                        model: {
                          value: _vm.question.year,
                          callback: function($$v) {
                            _vm.$set(_vm.question, "year", $$v)
                          },
                          expression: "question.year"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "地区", prop: "address" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.question.address,
                            callback: function($$v) {
                              _vm.$set(_vm.question, "address", $$v)
                            },
                            expression: "question.address"
                          }
                        },
                        _vm._l(_vm.provinceAndCityData, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.label }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "来源类型",
                        prop: "source",
                        "label-width": "90px"
                      }
                    },
                    [
                      _c("source-list", {
                        staticStyle: { width: "150px" },
                        model: {
                          value: _vm.question.sourceTypeId,
                          callback: function($$v) {
                            _vm.$set(_vm.question, "sourceTypeId", $$v)
                          },
                          expression: "question.sourceTypeId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showMatrix
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否母题",
                            prop: "isMatrix",
                            "label-width": "90px"
                          }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.question.isMatrix,
                                callback: function($$v) {
                                  _vm.$set(_vm.question, "isMatrix", $$v)
                                },
                                expression: "question.isMatrix"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("是")
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: null } }, [
                                _vm._v("否")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "题目来源",
                        prop: "source",
                        "label-width": "90px"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          autocomplete: "off",
                          clearable: "",
                          placeholder: "请输入"
                        },
                        model: {
                          value: _vm.question.source,
                          callback: function($$v) {
                            _vm.$set(_vm.question, "source", $$v)
                          },
                          expression: "question.source"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "is-required",
              attrs: { label: "题干", prop: "content" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "inputs",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  !_vm.question.contentShow
                    ? _c("div", {
                        staticClass: "input-editor content-html",
                        class: { empty: !_vm.question.content },
                        domProps: { innerHTML: _vm._s(_vm.question.content) },
                        on: {
                          click: function($event) {
                            return _vm.showUeEditor("contentShow")
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.question.contentShow
                    ? _c("ue-editor", {
                        attrs: {
                          height: 200,
                          type: "question",
                          marktk: _vm.question.questionType == 5
                        },
                        on: { change: _vm.editorCallback },
                        model: {
                          value: _vm.question.content,
                          callback: function($$v) {
                            _vm.$set(_vm.question, "content", $$v)
                          },
                          expression: "question.content"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.question.questionType == 1 ||
          _vm.question.questionType == 2 ||
          _vm.question.questionType == 4
            ? _c(
                "el-form-item",
                {
                  staticClass: "is-required",
                  attrs: { label: "内容", prop: "options" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "options" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "add-options",
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function($event) {
                              return _vm.addOptions()
                            }
                          }
                        },
                        [_vm._v("添加项目")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.question.questionOptionViewModels, function(
                        item,
                        index
                      ) {
                        return _c(
                          "div",
                          { key: index, staticClass: "option-list" },
                          [
                            _vm.question.questionType == 4
                              ? _c("span", {
                                  staticClass: "order type4",
                                  class: {
                                    active:
                                      _vm.question.answer.findIndex(function(
                                        s
                                      ) {
                                        return s.orderSort == item.orderSort
                                      }) >= 0
                                  },
                                  domProps: {
                                    innerHTML: _vm._s(item.orderSort)
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.selectOrder(item, index)
                                    }
                                  }
                                })
                              : _c("span", { staticClass: "order" }, [
                                  _vm._v(_vm._s(_vm.getEN(index)))
                                ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "inputs",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                  }
                                }
                              },
                              [
                                !item.optionShow
                                  ? _c("div", {
                                      staticClass: "input-editor content-html",
                                      class: { empty: !item.optionContent },
                                      domProps: {
                                        innerHTML: _vm._s(item.optionContent)
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.showUeEditor(
                                            "optionShow",
                                            item
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                item.optionShow
                                  ? _c("ue-editor", {
                                      attrs: { height: 200, type: "question" },
                                      on: { change: _vm.editorCallback },
                                      model: {
                                        value: item.optionContent,
                                        callback: function($$v) {
                                          _vm.$set(item, "optionContent", $$v)
                                        },
                                        expression: "item.optionContent"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "deleted-btn el-icon-remove",
                                  on: {
                                    click: function($event) {
                                      return _vm.deletedOptions(item, index)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.question.questionType != 6
            ? _c(
                "el-form-item",
                {
                  staticClass: "is-required",
                  attrs: { label: "答案", prop: "questionAnswer" }
                },
                [
                  _vm.question.questionType == 1 ||
                  _vm.question.questionType == 2
                    ? _c(
                        "ul",
                        { staticClass: "select-answer" },
                        [
                          _vm._l(
                            _vm.question.questionOptionViewModels,
                            function(item, index) {
                              return _c(
                                "li",
                                {
                                  key: index,
                                  class: { active: item.isTrue },
                                  on: {
                                    click: function($event) {
                                      return _vm.setSelectAnswer(item)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getEN(index)))]
                              )
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticStyle: { border: "none", width: "auto" } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "font-13 ml-5",
                                  staticStyle: { color: "#aaa" }
                                },
                                [_vm._v("点击答案选项选择参考答案")]
                              )
                            ]
                          )
                        ],
                        2
                      )
                    : _vm.question.questionType == 3
                    ? _c(
                        "ul",
                        { staticClass: "judge-fill-answer" },
                        [
                          _vm.question.answer.length == 0
                            ? _c("span", {
                                staticClass: "el-icon-circle-plus edit-btn",
                                on: {
                                  click: function($event) {
                                    return _vm.addAnswer(_vm.index)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.question.answer, function(item, index) {
                            return _c(
                              "li",
                              { key: index, staticClass: "center" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "order",
                                    class: ["type" + _vm.question.questionType]
                                  },
                                  [_vm._v(_vm._s(index + 1))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { size: "mini" },
                                    model: {
                                      value: item.answerArray,
                                      callback: function($$v) {
                                        _vm.$set(item, "answerArray", $$v)
                                      },
                                      expression: "item.answerArray"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio-button",
                                      { attrs: { label: "true" } },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "answer-label el-icon-check"
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-radio-button",
                                      { attrs: { label: "false" } },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "answer-label el-icon-close"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "edit" }, [
                                  _c("span", {
                                    staticClass: "el-icon-circle-plus edit-btn",
                                    attrs: { title: "添加平级答案" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addAnswer(index)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "el-icon-remove edit-btn",
                                    attrs: { title: "删除答案" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteAnswer(index)
                                      }
                                    }
                                  })
                                ])
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    : _vm.question.questionType == 4
                    ? _c(
                        "ul",
                        { staticClass: "order-answer" },
                        [
                          _vm._l(_vm.question.answer, function(item, index) {
                            return _c("li", {
                              key: index,
                              staticClass: "order-sort",
                              domProps: { innerHTML: _vm._s(item.orderSort) }
                            })
                          }),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticStyle: { border: "none", width: "auto" } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "font-13 ml-5",
                                  staticStyle: { color: "#aaa" }
                                },
                                [_vm._v("点击内容选项中序号排列顺序")]
                              )
                            ]
                          )
                        ],
                        2
                      )
                    : _c(
                        "ul",
                        { staticClass: "judge-fill-answer" },
                        [
                          _vm.question.answer.length == 0
                            ? _c("span", {
                                staticClass: "el-icon-circle-plus edit-btn",
                                on: {
                                  click: function($event) {
                                    return _vm.addAnswer(_vm.index)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.question.answer, function(item, index) {
                            return _c(
                              "li",
                              { key: index, staticClass: "mb-5" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "order",
                                    class: ["type" + _vm.question.questionType]
                                  },
                                  [_vm._v(_vm._s(index + 1))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "inputs",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                      }
                                    }
                                  },
                                  [
                                    !item.optionShow
                                      ? _c("div", {
                                          staticClass:
                                            "input-editor content-html",
                                          class: { empty: !item.answerContent },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              item.answerContent
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.showUeEditor(
                                                "optionShow",
                                                item
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.optionShow
                                      ? _c("ue-editor", {
                                          attrs: {
                                            height: 200,
                                            type: "question"
                                          },
                                          on: { change: _vm.editorCallback },
                                          model: {
                                            value: item.answerContent,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item,
                                                "answerContent",
                                                $$v
                                              )
                                            },
                                            expression: "item.answerContent"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "similar-box" },
                                      _vm._l(item.similarityAnswers, function(
                                        sim,
                                        sort
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: sort,
                                            staticClass: "similar-item"
                                          },
                                          [
                                            !sim.optionShow
                                              ? _c("div", {
                                                  staticClass:
                                                    "input-editor content-html",
                                                  class: {
                                                    empty: !sim.answerContent
                                                  },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      sim.answerContent
                                                    )
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showUeEditor(
                                                        "optionShow",
                                                        sim
                                                      )
                                                    }
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            sim.optionShow
                                              ? _c("ue-editor", {
                                                  attrs: {
                                                    height: 200,
                                                    type: "question"
                                                  },
                                                  on: {
                                                    change: _vm.editorCallback
                                                  },
                                                  model: {
                                                    value: sim.answerContent,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        sim,
                                                        "answerContent",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "sim.answerContent"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "edit" },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "el-icon-circle-plus edit-btn",
                                                  attrs: {
                                                    title: "添加平级答案"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.addSimilarAnswer(
                                                        item,
                                                        sort
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass:
                                                    "el-icon-remove edit-btn",
                                                  attrs: { title: "删除答案" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.deleteSimilarAnswer(
                                                        item,
                                                        sort
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "edit" }, [
                                  _c("span", {
                                    staticClass: "el-icon-circle-plus edit-btn",
                                    attrs: { title: "添加平级答案" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addAnswer(index)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "el-icon-remove edit-btn",
                                    attrs: { title: "删除答案" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteAnswer(index)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass:
                                      "el-icon-caret-bottom edit-btn",
                                    attrs: { title: "添加相似答案" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addSimilarAnswer(item)
                                      }
                                    }
                                  })
                                ])
                              ]
                            )
                          })
                        ],
                        2
                      )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "解析", prop: "questionAnswerAnalysisContent" } },
            [
              _c(
                "div",
                {
                  staticClass: "inputs",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  !_vm.question.questionAnswerAnalysisContentShow
                    ? _c("div", {
                        staticClass: "input-editor content-html",
                        class: {
                          empty: !_vm.question.questionAnswerAnalysisContent
                        },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.question.questionAnswerAnalysisContent
                          )
                        },
                        on: {
                          click: function($event) {
                            return _vm.showUeEditor(
                              "questionAnswerAnalysisContentShow"
                            )
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.question.questionAnswerAnalysisContentShow
                    ? _c("ue-editor", {
                        attrs: { height: 200, type: "question" },
                        on: { change: _vm.editorCallback },
                        model: {
                          value: _vm.question.questionAnswerAnalysisContent,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.question,
                              "questionAnswerAnalysisContent",
                              $$v
                            )
                          },
                          expression: "question.questionAnswerAnalysisContent"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.platform == "pc"
            ? [
                _c(
                  "el-form-item",
                  {
                    staticClass: "fx-1",
                    attrs: { label: "知识点", prop: "knowledgePoints" }
                  },
                  [
                    _c("knowledge-list", {
                      staticStyle: { width: "75%" },
                      attrs: {
                        disabled: !_vm.question.subjectCatalogueId,
                        defaults: _vm.question.knowledgePointViewModels,
                        subjectCatalogueId: _vm.question.subjectCatalogueId,
                        multiple: true
                      },
                      on: { change: _vm.knowledgePointChange },
                      model: {
                        value: _vm.question.knowledgePoints,
                        callback: function($$v) {
                          _vm.$set(_vm.question, "knowledgePoints", $$v)
                        },
                        expression: "question.knowledgePoints"
                      }
                    }),
                    _vm._v(" "),
                    !_vm.question.subjectCatalogueId
                      ? _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.type != "upload",
                                expression: "type!='upload'"
                              }
                            ],
                            staticClass: "mt-5 color-999"
                          },
                          [_vm._v("注：编辑编辑知识点需选择专业课程")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            : [
                _c(
                  "el-form-item",
                  {
                    staticClass: "fx-1",
                    attrs: {
                      label: "知识点",
                      prop: "knowledgePoints",
                      "label-width": "70px"
                    }
                  },
                  [
                    _c("knowledge-list", {
                      staticStyle: { width: "75%" },
                      attrs: {
                        disabled: !_vm.question.subjectCatalogueId,
                        defaults: _vm.question.knowledgePointViewModels,
                        subjectCatalogueId: _vm.question.subjectCatalogueId,
                        multiple: true
                      },
                      on: { change: _vm.knowledgePointChange },
                      model: {
                        value: _vm.question.knowledgePoints,
                        callback: function($$v) {
                          _vm.$set(_vm.question, "knowledgePoints", $$v)
                        },
                        expression: "question.knowledgePoints"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "fx-1",
                    attrs: {
                      label: "问题类型",
                      prop: "variantId",
                      "label-width": "70px"
                    }
                  },
                  [
                    _c("variant-cascader", {
                      attrs: {
                        disabled: !_vm.question.subjectCatalogueId,
                        subjectCatalogueId: _vm.question.subjectCatalogueId
                      },
                      on: { change: _vm.emitData },
                      model: {
                        value: _vm.question.variantId,
                        callback: function($$v) {
                          _vm.$set(_vm.question, "variantId", $$v)
                        },
                        expression: "question.variantId"
                      }
                    }),
                    _vm._v(" "),
                    !_vm.question.subjectCatalogueId
                      ? _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.type != "upload",
                                expression: "type!='upload'"
                              }
                            ],
                            staticClass: "mt-5 color-999"
                          },
                          [_vm._v("注：编辑编辑知识点和问题类型需选择专业课程")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
          _vm._v(" "),
          _vm.question.parentId
            ? _c(
                "el-form-item",
                { attrs: { label: "排序号", prop: "sort" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, max: 10000, placeholder: "请输入" },
                    model: {
                      value: _vm.question.sort,
                      callback: function($$v) {
                        _vm.$set(_vm.question, "sort", $$v)
                      },
                      expression: "question.sort"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.showVerification
        ? _c(
            "el-checkbox",
            {
              staticStyle: { position: "absolute", top: "0px", right: "20px" },
              model: {
                value: _vm.question.isVerification,
                callback: function($$v) {
                  _vm.$set(_vm.question, "isVerification", $$v)
                },
                expression: "question.isVerification"
              }
            },
            [_vm._v("已检查")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62cb7180", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62cb7180","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionEdit.vue
// module id = 569
// module chunks = 14